export default __webpack_public_path__ + "static/media/Whatsapp-Icon.4d5e9a48.png";